import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Container } from '@material-ui/core';
import ProductCard from 'src/components/product//ProductCard';
import { URL } from '../utils/factory';

const axios = require('axios');

const ProductList = () => {
  const [invoicelist, setInvoicelList] = useState([]);

  const loadNoteData = async () => {
    const clientid = localStorage.getItem('tranuserid');
    try {
      axios
        .post(`${URL}trans_loaditems`, {
          userid: clientid,
          qtype: '6',
          searchtext: '',
          fdate: '',
          tdate: '',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
          }
        })
        .then((response) => {
          if (response.data.d.length > 0) {
            // eslint-disable-next-line no-eval
            const userdata = eval(response.data.d);
            setInvoicelList(userdata);
          } else setInvoicelList([]);
        })
        .catch((error) => {
          console.log('API error', error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    loadNoteData();
  }, []);

  return (
    <>
      <Helmet>
        <title>Notification List</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <Box sx={{ pt: 3 }}>
            <ProductCard product={invoicelist} />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default ProductList;
